import React from "react";
import ModalComponent from "../../components/modalComponent";
import ButtonComponent from "../../components/button";

const ConfirmationModal = ({ open, onClose, rowData, onSubmitFunction }) => {
  if (!open) return null;

  const handleConfirm = () => {
    onSubmitFunction(); 
    onClose();
  };

  return (
    <ModalComponent open={open} onClose={onClose} title="Confirmación">
      <div style={{ padding: "20px", fontSize: "16px" }}>
        <p>
          ¿Estás seguro que desea <strong>eliminar la base de datos</strong>?
        </p>

        {rowData?.name && (
          <p style={{ marginTop: "10px", opacity: 0.8 }}>
            <strong>DB:</strong> {rowData.name}
          </p>
        )}

        {rowData?.shardKey && (
          <p style={{ opacity: 0.8 }}>
            <strong>ShardKey:</strong> {rowData.shardKey}
          </p>
        )}

        <div className="HContainer j-center mt-20" style={{ gap: "15px" }}>
          <ButtonComponent
            onClick={onClose}
            backgroundColor="#CCCCCC"
            textColor="#000"
            width="140px"
          >
            Cancelar
          </ButtonComponent>

          <ButtonComponent
            onClick={handleConfirm}
            backgroundColor="#F6C079"
            textColor="#000"
            width="140px"
          >
            Confirmar
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
};

export default ConfirmationModal;
